import { circuitService } from "@/_services";

export default {
  namespaced: true,

  state: {
    customerRegions: [],
    hideInactiveCircuits: true
  },

  mutations: {
    setCustomerRegions(state, regions) {
      state.customerRegions = Array.isArray(regions) ? regions : [];
    },

    setHideInactiveCircuits(state, value) {
      state.hideInactiveCircuits = value;
    }
  },

  actions: {
    async loadCustomerRegions({ commit }) {
      try {
        const response = await circuitService.getCustomerRegions();

        // Adjust depending on backend response shape
        const regions = Array.isArray(response.data)
          ? response.data
          : response.data.regions;

        commit("setCustomerRegions", regions);
      } catch (error) {
        commit("setCustomerRegions", []);
        throw error;
      }
    },

    toggleInactiveCircuit({ commit }, value) {
      commit("setHideInactiveCircuits", value);
    }
  },

  getters: {
    customerRegionOptions(state) {
      return state.customerRegions.map(region => ({
        text: region,
        value: region
      }));
    },

    isMultiRegional(state) {
      return state.customerRegions.length > 0;
    }
  }
};